var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgComment(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.926,
    height: 15.585,
    viewBox: "0 0 16.926 15.585",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_34345",
    "data-name": "Group 34345",
    transform: "translate(-1031.759 -217.198)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon",
    transform: "translate(1031.759 223.198)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon-2",
    "data-name": "Icon",
    d: "M14.575,0H2.351A2.357,2.357,0,0,0,0,2.363V9.925a2.357,2.357,0,0,0,2.351,2.363h1.41v3.287a.009.009,0,0,0,.016.007l3.746-3.295h7.052a2.357,2.357,0,0,0,2.351-2.363V2.363A2.357,2.357,0,0,0,14.575,0Z",
    transform: "translate(0 -6)",
    fill: "#b6c0ce"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComment);
export default __webpack_public_path__ + "static/media/comment.343e865417ff6cb6216f10a1d7b2ec6c.svg";
export { ForwardRef as ReactComponent };